<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <h1>DeliveryNote</h1>
        <v-text-field
          filled
          data-cy="FormDeliveryNote-receivingDate"
          :label="$$t('receivingDate')"
          v-model="localDeliveryNote.receivingDate"
               v-mask="'####-##-##'"
               hint="YYYY-MM-DD"
        />
        <v-select
          data-cy="FormDeliveryNote-farmId"
          filled
          :label="$$t('farmId')"
          :items="items"
          v-model="localDeliveryNote.farmId"
        ></v-select>
        <v-text-field
          filled
          data-cy="FormDeliveryNote-goodsReceivedNumber"
          :label="$$t('goodsReceivedNumber')"
          v-model="localDeliveryNote.goodsReceivedNumber"
        />
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormDeliveryNote-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="$parent.isSaving"
            data-cy="FormDeliveryNote-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
export default {
  name: 'FormDeliveryNote',
  module: 'DeliveryNote',
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    DeliveryNote: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localDeliveryNote
      */
      localDeliveryNote: {},
    };
  },
  watch: {
    DeliveryNote() {
      this.localDeliveryNote = this.DeliveryNote;
    },
  },
  created() {
    this.localDeliveryNote = this.DeliveryNote;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localDeliveryNote);
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormDeliveryNote example

'''js
<FormDeliveryNote :DeliveryNote="DeliveryNote" />
'''
</docs>
